module.exports = __webpack_public_path__ + "static/img/logo.eae81aa8.png";